import { render } from "./BottomListPhotoTagsView.vue?vue&type=template&id=0eb6b554&scoped=true"
import script from "./BottomListPhotoTagsView.vue?vue&type=script&lang=js"
export * from "./BottomListPhotoTagsView.vue?vue&type=script&lang=js"

import "./BottomListPhotoTagsView.vue?vue&type=style&index=0&id=0eb6b554&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb6b554"]])

export default __exports__